import React from "react";
import ReactDOM from "react-dom";
import "./cssReset.css";
import App from "./App";
import { defaults } from "react-sweet-state";
import { isProd } from "./utils/is-prod";

defaults.devtools = !isProd();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
